import { Login } from "../../imports";

export const NoPermitsValue = () => {};
export default function NoPermits() {
  return <Login unauthorized />;
}
